import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Data2Service } from '../../common/data2.service';
import { AuthService } from '../auth.service';

@Component({
	selector: 'app-remind-password',
	templateUrl: './remind-password.component.html',
})
export class RemindPasswordComponent implements OnInit {
	email: string;
	formError: string;
	formDone: string;
	code: string;
	password: string;
	password2: string;

	constructor(
		private readonly auth: AuthService,
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.auth.check();
		if (this.route.snapshot.params['code'] !== undefined) {
			this.code = this.route.snapshot.params['code'];
		}
	}

	onSubmitEmail(): void {
		this.api.post('/remindPassword?cmd=send', { email: this.email }, (result, error) => {
			if (error) {
				this.formError = error.error.error;
				return;
			}
			this.formError = '';
			this.formDone = 'Link do zmiany hasła został wysłany na Twój adres e-mail';
		});
	}

	onSubmitPass(): void {
		this.api.post(
			'/remindPassword?cmd=change',
			{ code: this.code, password: this.password, password2: this.password2 },
			(result, error) => {
				if (error) {
					this.formError = error.error.error;
					return;
				}
				this.formError = '';
				this.formDone = 'Hasło ustawione pomyślnie!';
			},
		);
	}
}
